import { useState } from 'react';
import PropTypes from 'prop-types';

import SubSlider from '../Slider/SubSlider';
import { renderCardPrice } from '../../../utils/helpers/formater';

import Loader from '../Loader';
import DesktopComponent from './desktopUi/scoreItems';
import MobileComponent from './mobileUi/scoreItems';
import { renderCardLivingSpace } from '../../../utils/helpers/formater';
import useResize from '../../../utils/hooks/useResize';
import { Row, Col } from 'antd';

const Cards = ({ detailList, viva, offers, selectedLayer, goToLocation }) => {
  const screenWidth = useResize();
  const [expand, setExpand] = useState(null);

  const handleChange = (item, type, e) => {
    if (item.id && item.id !== expand?.id && type !== expand?.type) {
      e.stopPropagation();
      return setExpand({ id: item.id, type });
    }
    return setExpand(null);
  };
  const handleCloseAccordionOutsideClick = () => setExpand(null);

  return (
    <>
      {/* eslint-disable-next-line no-nested-ternary */}
      {offers?.items?.length !== 0 && offers?.loadingState === false ? (
        <>
          <main
            className="cards"
            data-cy="listings"
            onClick={() => handleCloseAccordionOutsideClick()}
            aria-hidden
          >
            {offers.items.map((item) => (
              <div className="cards__container" key={item.id}>
                <article
                  role="presentation"
                  className="cards__container--inner"
                  key={item.id}
                >
                  <div className="cards__img">
                    <SubSlider
                      isShowIndicators
                      items={item}
                      images={item.images}
                      detailList={detailList}
                      isCard
                    />
                  </div>
                  <section className="cards__details">
                    <div className="cards__rent-size-room">
                      <p>
                        <strong>
                          {`${
                            item.netRent
                              ? renderCardPrice(item.netRent)
                              : renderCardPrice(item.price)
                          }`}
                        </strong>
                        <br />
                        <span>{`${
                          item.netRent ? 'Kaltmiete' : 'Kaufpreis'
                        }`}</span>
                      </p>
                      <p>
                        <strong>
                          {renderCardLivingSpace(item?.livingSpace)}
                        </strong>
                        <br />
                        <span>Wohnfläche (ca)</span>
                      </p>
                      <p>
                        <strong>{item.numberOfRooms}</strong>
                        <br />
                        <span>Zimmer</span>
                      </p>
                    </div>
                    <header className="cards__header">
                      {/* <Link href={''} passHref> */}
                      <a
                        data-cy="card-title"
                        onClick={() => {
                          goToLocation([item.lng, item.lat]);
                        }}
                      >
                        <div className="cards__header--title">
                          <span style={{ marginRight: '5px' }}>
                            {item.street && item.houseNumber
                              ? `${item.street} ${item.houseNumber}, `
                              : `${item.city} - ${item.district}, `}
                          </span>
                          <span>{`${item.zipCode} ${item.city}`}</span>
                        </div>
                        {item.netRent && (
                          <span
                            style={{ display: 'block', fontWeight: 'bold' }}
                          >
                            Gesamtmiete: &nbsp;
                            {item.warmRent && renderCardPrice(item.warmRent)}
                          </span>
                        )}
                      </a>
                      {/* </Link> */}
                    </header>
                    <Row span={14}>
                      <Col flex={13}>
                        {' '}
                        <span className="cards__iib-lagescore">
                          IIB Lagescores:
                        </span>
                      </Col>
                    </Row>
                    {screenWidth > 770 ? (
                      <DesktopComponent
                        newScore={item?.wohnlage}
                        cultureScore={item?.culture}
                        localSupply={item?.localSupply}
                        publicTransport={item?.publicTransport}
                        item={item}
                        viva={viva}
                        selectedLayer={selectedLayer}
                      />
                    ) : (
                      <MobileComponent
                        newScore={item?.wohnlage}
                        cultureScore={item?.culture}
                        localSupply={item?.localSupply}
                        publicTransport={item?.publicTransport}
                        item={item}
                        viva={viva}
                        selectedLayer={selectedLayer}
                        handleChange={handleChange}
                        expand={expand}
                      />
                    )}
                    <div className="einfach-top">
                      <p>einfach</p>
                      <p>top</p>
                    </div>
                  </section>
                </article>
              </div>
            ))}
          </main>
        </>
      ) : offers?.loadingState ? (
        <Loader />
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '500px',
            flexDirection: 'column',
          }}
        >
          <p>No result found</p>
        </div>
      )}
    </>
  );
};

Cards.propTypes = {
  detailList: PropTypes.bool,
  viva: PropTypes.number.isRequired,
  offers: PropTypes.shape({
    loadingState: PropTypes.bool,
    items: PropTypes.array,
  }),
};

Cards.defaultProps = {
  detailList: false,
  offers: { items: [], loadingState: false },
};

export default Cards;
